import { render } from "./index.vue?vue&type=template&id=5c2c6c8c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5c2c6c8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2c6c8c"],['__file',"src/components/DialogComment/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c2c6c8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c2c6c8c', __exports__)) {
    api.reload('5c2c6c8c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=5c2c6c8c&scoped=true", () => {
    api.rerender('5c2c6c8c', render)
  })

}


export default __exports__